import { useEffect, useRef, useState } from "react";
import Catagory from "../../actions/Catagory";
import UploadImage from "../../actions/uploadImage";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";
import { Image_API } from "../../config";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
const initialFValues = {
  name: "",
  description: "",
  image: null,
  editing: false,
};

const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
  errorText: {
    fontSize: "0.75rem",
    marginTop: "0.25rem",
  },
}));

const AddMaincatagory = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  setCategories,
  edite,
}) => {
  const classes = useStyles();
  const { addCatagory, updateCatagory } = Catagory();
  const { uploadImage } = UploadImage();
  const roomImagePicker = useRef(null);
  const [file, setfile] = useState(null);
  const [imageError, setImageError] = useState("");
  const firstFieldRef = useRef(null);

  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    if ("name" in fieldValues)
      temp.name =
        fieldValues.name.length !== 0 ? "" : "This field is required.";
    if ("description" in fieldValues)
      temp.description =
        fieldValues.description.length !== 0 ? "" : "This field is required.";
    if ("description" in fieldValues) {
      temp.description =
        fieldValues.description.length >= 4
          ? ""
          : "Description must be at least 4 characters.";
    }
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  const handleImageChange = (e) => {
    const { files } = e.target;
    if (files.length > 0) {
      const selectedFile = files[0];
      const maxSize = 1 * 1024 * 1024; // 1MB in bytes
      if (selectedFile.size > maxSize) {
        setImageError("Image size must be less than 1MB.");
        NotifyMessage({
          message: "Image size must be less than 1MB.",
          type: "error",
        });
        e.target.value = ""; // Clear the input
        return;
      }
      setImageError("");
      setfile(URL.createObjectURL(selectedFile));
      setValues({ ...values, image: selectedFile });
    }
  };

  useEffect(() => {
    if (recordForEdit !== null && edite) {
      setValues({
        ...recordForEdit,
        image: recordForEdit.image, // Keep existing image
      });
      setfile(
        recordForEdit.image ? `${Image_API}/${recordForEdit.image}` : null
      );
    }
  }, [recordForEdit]);

  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (values.image instanceof File) {
      formData.append("image", values.image);
    }

    if (validate()) {
      setValues({ ...values, submitting: true });

      if (!edite) {
        try {
          let imageUrl = null;
          if (values.image instanceof File) {
            const uploadResponse = await uploadImage(formData, "category");
            if (uploadResponse.err) {
              NotifyMessage({ message: uploadResponse.err, type: "error" });
              setValues({ ...values, submitting: false });
              return;
            }
            imageUrl = uploadResponse.data.data;
          }

          const categoryData = {
            name: values.name,
            description: values.description,
            image: imageUrl,
          };

          const addData = await addCatagory(categoryData);
          if (addData.err) {
            NotifyMessage({ message: addData.err, type: "error" });
            setValues({ ...values, submitting: false });
            return;
          }

          NotifyMessage({
            message: "Category successfully created",
            type: "success",
          });
          setOpenPopup(false);
          setCategories(
            produce((draft) => {
              draft.unshift({ ...addData.category });
            })
          );
          resetForm();
        } catch (error) {
          NotifyMessage({
            message: "Failed to create category!",
            type: "error",
          });
          setValues({ ...values, submitting: false });
        }
      } else {
        try {
          let imageUrl = recordForEdit.image;
          if (values.image instanceof File) {
            const uploadResponse = await uploadImage(formData, "category");
            if (uploadResponse.err) {
              NotifyMessage({ message: uploadResponse.err, type: "error" });
              setValues({ ...values, submitting: false });
              return;
            }
            imageUrl = uploadResponse.data.data;
          }

          const categoryData = {
            name: values.name,
            description: values.description,
            image: imageUrl,
          };

          const updateData = await updateCatagory(categoryData, values.id);
          if (updateData.err) {
            NotifyMessage({ message: updateData.err, type: "error" });
            setValues({ ...values, submitting: false });
            return;
          }

          NotifyMessage({
            message: "Category successfully updated",
            type: "success",
          });
          setOpenPopup(false);
          setCategories(
            produce((draft) => {
              const index = draft.findIndex(
                (category) => category.id === recordForEdit.id
              );
              if (index !== -1) draft[index] = updateData.categorie;
            })
          );
          resetForm();
        } catch (error) {
          NotifyMessage({
            message: "Failed to update category!",
            type: "error",
          });
          setValues({ ...values, submitting: false });
        }
      }
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="name"
            label="Name"
            value={values.name}
            onChange={handleInputChange}
            error={errors.name}
            inputRef={firstFieldRef}
          />
          <Controls.Input
            name="description"
            label="Description"
            value={values.description}
            onChange={handleInputChange}
            error={errors.description}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <div className="flex space-x-3 items-center">
            {file ? (
              <img className={classes.icon} src={file} alt="Category Preview" />
            ) : (
              <img
                className={classes.icon}
                src={
                  recordForEdit?.image
                    ? `${Image_API}/${recordForEdit.image}`
                    : "/default-image.png"
                }
                alt="Category Preview"
              />
            )}
            <Controls.Button
              color="primary"
              onClick={() => {
                roomImagePicker.current.click();
              }}
              variant="outlined"
              text={recordForEdit ? "Change Image" : "Add Image"}
              className="newButton"
            />
            <input
              name="image"
              type="file"
              hidden
              accept="image/*"
              ref={roomImagePicker}
              onChange={handleImageChange}
            />
          </div>
          {imageError && <p className={classes.errorText}>{imageError}</p>}
        </Grid>
        <Grid item xs={12}>
          <div>
            <Controls.Button
              disabled={values.submitting || imageError}
              text={
                edite
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              type="submit"
            />
            <Controls.Button
              text="Cancel"
              color="default"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddMaincatagory;
